import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const SeptemberSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={9} title="September Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default SeptemberSehriIftaar;
